// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface AlertTriangleFilledIconSignature {
  Element: SVGSVGElement;
}

export const AlertTriangleFilledIcon: TOC<AlertTriangleFilledIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.85 21.526C21.668 21.821 21.347 22 21 22H3C2.653 22 2.332 21.82 2.149 21.526C1.966 21.23 1.951 20.863 2.105 20.552L11.105 2.552C11.444 1.875 12.555 1.875 12.894 2.552L21.894 20.552C22.048 20.863 22.033 21.229 21.85 21.526ZM11 10H13V16H11V10ZM12 19.25C12.6904 19.25 13.25 18.6904 13.25 18C13.25 17.3096 12.6904 16.75 12 16.75C11.3096 16.75 10.75 17.3096 10.75 18C10.75 18.6904 11.3096 19.25 12 19.25Z"/>
</svg>
</template>;